
// // src/auth.js
// const STORAGE_KEY = "payslip_admin_auth";

// const STATIC_USER = {
//   username: "admin",
//   password: "Quantum@123",   // ← change to whatever you want
// };

// export function login(username, password) {
//   if (
//     username === STATIC_USER.username &&
//     password === STATIC_USER.password
//   ) {
//     localStorage.setItem(STORAGE_KEY, "true");
//     return true;
//   }
//   return false;
// }

// export function logout() {
//   localStorage.removeItem(STORAGE_KEY);
// }

// export function isLoggedIn() {
//   return localStorage.getItem(STORAGE_KEY) === "true";
// }

import api from "./api";

const STORAGE_KEY = "payslip_admin_auth";

function saveSession(session) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
}

export function getAuthSession() {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;

  // backward compatibility: old "true" string
  if (raw === "true") {
    const adminSession = { role: "admin" };
    saveSession(adminSession);
    return adminSession;
  }

  try {
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
}

export function logout() {
  localStorage.removeItem(STORAGE_KEY);
}

export function isLoggedIn() {
  return !!getAuthSession()?.role;
}

export function isManager() {
  return getAuthSession()?.role === "manager";
}

export function isAdmin() {
  return getAuthSession()?.role === "admin";
}

export function loginAdmin(username, password) {
  return api
    .post("/admin/auth/login", { username, password })
    .then((res) => {
      const session = {
        role: "admin",
        name: res.data?.name || "Admin",
        token: res.data?.token,
      };
      saveSession(session);
      return { ok: true, session };
    })
    .catch((err) => {
      const message =
        err?.response?.data?.message || "Invalid admin credentials";
      return { ok: false, message };
    });
}

export async function loginManager(username, password) {
  try {
    const res = await api.post("/employee/auth/login", {
      username,
      password,
      as_manager: true,
    });
    const session = {
      role: "manager",
      token: res.data.token,
      employee: res.data.employee,
    };
    saveSession(session);
    return { ok: true, session };
  } catch (err) {
    const message =
      err?.response?.data?.message || "Manager login failed";
    return { ok: false, message };
  }
}
